
















































































/* eslint-disable */
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import ProvisaoStore from '@/store/Provisao'

@Component

export default class ComponentProvisaoDadosIniciais extends Vue {
  @Prop(Boolean) show

  getProfissionalExecutantes() {
    const profissionalExecutantes = this.funcao.profissionaisExecutantes.filter(p => p.status === false)
    return profissionalExecutantes.sort((n1, n2) => {
      if (n1.funcao > n2.funcao) {
        return 1
      }

      if (n1.funcao < n2.funcao) {
        return -1
      }

      return 0
    })
  }

  getSumProcedimento(profissionalExecutante) {
    const descricao = this.getFuncaoValorDescricao(profissionalExecutante.funcao)

    return this.provisao.calculadora.procedimentos.reduce((target, source) => {
        return target + source[descricao]
    }, 0)
  }

  isEnableVisualizarFuncao(codFuncao) {
    const perfil = ProvisaoStore.getters.PERFIL_PROFISSIONAL_EXECUTANTE

    if (perfil.isGestor) {
      return true
    }

    if (this.funcao.userCodLogged === codFuncao) {
      return true
    }

    return false
  }

  getFuncaoValorDescricao(funcao) {

    switch (funcao) {
      case 0:
        return 'valorProfissionalPrincipal'

      case 1:
        return 'valorPrimeiroAuxiliar'

      case 2:
        return 'valorSegundoAuxiliar'

      case 3:
        return 'valorTerceiroAuxiliar'

      case 4:
        return 'valorQuartoAuxiliar'

      case 5:
        return 'valorInstrumentador'

      case 6:
        return 'valorAnestesista'

      default:
        return ''
    }
  }

  getFuncaoDescricao(funcao) {

    switch (funcao) {
      case 0:
        return 'Médico Principal'

      case 1:
        return '1° Auxiliar'

      case 2:
        return '2° Auxiliar'

      case 3:
        return '3° Auxiliar'

      case 4:
        return '4° Auxiliar'

      case 5:
        return 'Instrumentador'

      case 6:
        return 'Anestesista'

      default:
        return ''
    }
  }

  getProcedimentos(profissionalExecutante) {
    const descricao = this.getFuncaoValorDescricao(profissionalExecutante.funcao)

    return this.calculadora.procedimentos.reduce((target, source) => {
        var funcaoDescricao = this.getFuncaoDescricao(profissionalExecutante.funcao)
          target.push({ funcao: funcaoDescricao,
                        valor: source[descricao],
                        codigo: source.codigo,
                        descricao: source.descricao })
      return target
    },[])
  }

  get showProvisaoResumo(): Boolean {
    return ProvisaoStore.getters.DIALOG_RESUMO
  }

  set showProvisaoResumo(newValue) {
    ProvisaoStore.commit('DIALOG_RESUMO', newValue)
  }

  get totalProvisao() {
    return ProvisaoStore.getters.PROVISAO_VALOR_TOTAL
  }

  get calculadora() {
    return ProvisaoStore.getters.CALCULADORA
  }

  get provisao() {
    return ProvisaoStore.getters.PROVISAO
  }

  get funcao() {
    return ProvisaoStore.getters.FUNCAO
  }

  @Emit('close')
  close() {}

  mounted() {
  }
}
